import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { FamiliaService } from 'src/app/services/familia.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { FamiliaModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';

@Component({
  selector: 'app-familia',
  templateUrl: './familia.component.html',
  styleUrls: ['./familia.component.scss'],
  providers: [SecurityService],
})
export class FamiliaComponent implements OnInit {

  @ViewChild(FamiliaModalAddEditComponent, { static: true }) modalAddEditFamilia: FamiliaModalAddEditComponent
  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  listaFamilias: Array<any> = null
  //inputParams: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loadAll: boolean = false
  public activos;
  public inactivos;
  public todos;
  public busquedaEstado;
  filtroNombre: string = ""; 

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private familiaService: FamiliaService
  ) { }

  ngOnInit() {
    this.createForm()
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())

    this.paginationContext.RecordsByPage = 10
    this.busquedaEstado = 3
    //this.loadOperaciones()
    this.buscar()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      nombre: [''],
    });
  }

  openModalFamilia() {
    this.modalAddEditFamilia.show()
  }

  buscar() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        nombre: this.filtroNombre,
        tipobusqueda: this.busquedaEstado
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
      paginaActual: this.paginationContext.CurrentPage
    }
    this.familiaService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.renderResults(respuesta)
    })
  }

  renderResults({ registros, paginaActual, totalPaginas, totalRegistros }) {
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.listaFamilias = registros
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  editar(familia) {
    this.modalAddEditFamilia.load(familia)
  }

  onAddEdit(familia) {
    this.buscar()
  }

  desactivar({ codigo, empresa_rut }) {
    const inputParams = {
      entidad: {
        codigo,
        empresa_rut,
        activo: false
      }
    }
    this.cambiarEstado(inputParams)
  }

  activar({ codigo, empresa_rut }) {
    const inputParams = {
      entidad: {
        codigo,
        empresa_rut,
        activo: true
      }
    }
    this.cambiarEstado(inputParams)
  }

  cambiarEstado(inputParams) {
    this.familiaService.cambiaEstado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.toastrService.success('Operación realizada con éxito')
      this.buscar()
    })
  }
}
